var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentLibraryActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.934,
    viewBox: "0 0 16 14.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.6,93.333h-.533A1.067,1.067,0,0,1,16,92.267v-11.2A1.067,1.067,0,0,1,17.067,80H17.6a1.067,1.067,0,0,1,1.067,1.067v11.2A1.067,1.067,0,0,1,17.6,93.333Z",
    transform: "translate(0 -46.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M116.267,145.067A1.067,1.067,0,0,0,115.2,144h-2.133A1.067,1.067,0,0,0,112,145.067V146a.133.133,0,0,0,.133.133h4a.133.133,0,0,0,.133-.133Z",
    transform: "translate(-92.8 -108.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M112,417.067a1.067,1.067,0,0,0,1.067,1.067H115.2a1.067,1.067,0,0,0,1.067-1.067v-1A.067.067,0,0,0,116.2,416h-4.133a.067.067,0,0,0-.067.067Z",
    transform: "translate(-92.8 -371.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.267,
    height: 4.8,
    rx: 1,
    transform: "translate(19.2 38.933)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M258.133,46.933h-1.067A1.067,1.067,0,0,1,256,45.867v-12.8A1.067,1.067,0,0,1,257.067,32h1.067a1.067,1.067,0,0,1,1.067,1.067v12.8A1.067,1.067,0,0,1,258.133,46.933Z",
    transform: "translate(-232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M372.259,92.156l-1.074-11.333a1.012,1.012,0,0,0-1.151-.844l-1.062.1A1.013,1.013,0,0,0,368,81.124l1.074,11.333a1.012,1.012,0,0,0,1.151.844l1.062-.1A1.013,1.013,0,0,0,372.259,92.156Z",
    transform: "translate(-340.263 -46.374)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLibraryActive);
export default __webpack_public_path__ + "static/media/content-library-active.9bb59245ad714a591e9a8f62dd888998.svg";
export { ForwardRef as ReactComponent };